import type { ThemeOptions } from '@mui/material';

const TabTheme: ThemeOptions['components'] = {
  MuiTabs: {
    styleOverrides: {
      root: ({ theme }) => ({
        minHeight: '32px',
        '.MuiTabs-flexContainer': {
          gap: theme.spacing(3),
        },
      }),
    },
  },
  MuiTab: {
    styleOverrides: {
      root: ({ theme }) => ({
        padding: 0,
        paddingBottom: theme.spacing(1.5),
        minHeight: '100%',
        color: theme.palette.secondary.dark,
        '&.Mui-selected': {
          color: theme.palette.primary.dark,
        },
        ...theme.typography.body1,
      }),
    },
  },
};

export default TabTheme;
